import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';

export const Breadcrumb = () => (
    <div>
        <Headline anchor='breadcrumb'>Breadcrumb</Headline>
        <Playground example={breadcrumbExample} />
    </div>
);

const breadcrumbExample = (
    <ul className='breadcrumb'>
        <li>
            <span className='btn btn-link btn-link-inline'>
                <span className='uikit-icon icon-home margin-right-0' />
            </span>
        </li>
        <li>
            <span className='link'>level 1</span>
        </li>
        <li>
            <span className='link'>level 2</span>
        </li>
        <li>
            <span className='link'>level 3</span>
        </li>
        <li className='active'>level 4</li>
    </ul>
);
